import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Status = ({ actionRequiredType, children, skipActionRequired }) => {
    if (!children) {
        return null;
    }

    const dotClass = classnames('t3 r-mrm', {
        invisible: !actionRequiredType,
        cherry: actionRequiredType === 'NEGATIVE',
        pea: actionRequiredType === 'POSITIVE',
    });

    return (
        <div className="pal flex align-items-center">
            {!skipActionRequired && <span className={dotClass}>&#8226;</span>}
            <div className="flex-grow1">{children}</div>
        </div>
    );
};

Status.propTypes = {
    actionRequiredType: PropTypes.oneOf(['POSITIVE', 'NEGATIVE']),
    children: PropTypes.node,
    skipActionRequired: PropTypes.bool,
};

Status.defaultProps = {
    skipActionRequired: false,
};

export default Status;



// WEBPACK FOOTER //
// ./safeTrade/status/status.jsx